<template>
    <div class="report-meter-rtc">
        <b-row class="py-1 icon-row">
            <div v-for="index in 5" :key="index">
                <div v-if="getIcon(index) === 'heart-fill'">
                    <b-icon icon="heart-fill" class="filled-icon"/>
                </div>
                <div v-if="getIcon(index) === 'heart'">
                    <b-icon icon="heart" class="empty-icon"/>
                </div>
                <div v-if="getIcon(index) === 'heart-half'">
                    <svg class="b-icon"
                         style="margin-bottom: -2px"
                         xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 16 16">
                        <path :fill="$utils.themeIs('wellcoaches') ? '#e83e8c' : '#ff0000'"
                            d="M 8,2.748 V 13.795 C 7.9843321,6.1973314 7.9982168,5.2514388 8,2.748 Z M 8,14.669354 C -5.9772354,3.6824876 2.9998598,-1.8025567 7.8507146,1.3633952 c 0.06,0.055 0.092285,0.225537 0.1492854,0.284537 0.00398,9.5683528 0.00418,3.7014265 0,13.0214218 z"
                            id="path2"/>
                        <path fill="#666"
                              d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"
                              id="path12" />
                    </svg>
                </div>
            </div>
            <!-- This is just a helper to view the accuracy of the gauge (shows numeric representation of score) -->
            <!-- {{scoreDef.score.score}} -->
        </b-row>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * Displays a filed circle gauge for a score value
 */
export default Vue.extend({
    name: "ReportMeterRtc",
    props: {
        scoreName: String,
        scaleTo5: {
            type: Boolean,
            default: false // otherwise, scale max is 100
        },
    },
    computed: {
        scoreDef () {
            return this.$store.state.patientParticipant.latestScoreDefs[this.scoreName]
        },
    },
    methods: {
        getIcon(pos) {
            const baseShape = 'heart'
            let val = this.scoreDef.score.score
            if (this.scaleTo5) {
                return pos <= val ? baseShape + '-fill' : baseShape
            } else {
                val = Math.round(val / 10)
                if (pos * 2 <= val) {
                    return baseShape + '-fill'
                } else if (pos * 2 - 1 === val) {
                    return baseShape + '-half'
                } else return baseShape
            }
        },
    }
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
    .report-meter-rtc {
        width: 100%;
        overflow: hidden;
        margin-left: auto;
        margin-right: auto;
        background-color: transparent;
        //display: inline-block;

        .report-meter__meter-label {
            font-size: .9em;
            color: #666;
            text-align: center;
            margin: -5px 0 10px 0;
        }
    }
    .icon-row {
        justify-content: center;
        color: red;

        .b-icon {
            $size: 20px;
            height: $size;
            width: $size;
            margin: 0 4px;
            @media (max-width: 991px) {
                $size: 16px;
                height: $size;
                width: $size;
                margin: 0 3px
            }
            @media (max-width: 520px) {
                margin: 0 1px
            }
        }

        .filled-icon {
            stroke: #666;
        }
        .empty-icon {
            color: #666;
        }
    }

</style>



